var _rect, _rect2, _g, _circle, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrial(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 51,
    height: 51,
    rx: 3.5,
    fill: "url(#paint0_linear_6056_179840)",
    stroke: "#D2D2D2"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6056_179840",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 50,
    height: 50
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 50,
    height: 50,
    rx: 2,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6056_179840)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 25.9999,
    r: 22.0243,
    stroke: "url(#paint1_linear_6056_179840)"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 26,
    r: 15,
    fill: "#B6D5EE"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6056_179840",
    x1: 26,
    y1: 0,
    x2: 26,
    y2: 52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBF5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6056_179840",
    x1: 15.5,
    y1: 46.5,
    x2: 43,
    y2: 8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9AD0EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7EDF9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrial);
export default __webpack_public_path__ + "static/media/Trial.eda97b041e03b4d8eac138291554e745.svg";
export { ForwardRef as ReactComponent };